export function getLineGuidelineIntersection(lineStart, lineEnd, guideline) {
  if (!guideline) return null;

  if (guideline.type === "vertical") {
    const x = guideline.position;
    // does segment cross x = position ?
    if (
      (lineStart.x < x && lineEnd.x > x) ||
      (lineStart.x > x && lineEnd.x < x)
    ) {
      const t = (x - lineStart.x) / (lineEnd.x - lineStart.x);
      // y at intersection
      const y = lineStart.y + t * (lineEnd.y - lineStart.y);
      if (t >= 0 && t <= 1) return { x, y };
    }
  } else if (guideline.type === "horizontal") {
    const y = guideline.position;
    // does segment cross y = position ?
    if (
      (lineStart.y < y && lineEnd.y > y) ||
      (lineStart.y > y && lineEnd.y < y)
    ) {
      const t = (y - lineStart.y) / (lineEnd.y - lineStart.y);
      const x = lineStart.x + t * (lineEnd.x - lineStart.x);
      if (t >= 0 && t <= 1) return { x, y };
    }
  }
  return null;
}
